document.addEventListener('DOMContentLoaded', () => {
  const previewCopyMap = {
    'standing seam roofing': 'Durable metal roofing systems for modern residential and commercial projects.',
    'metal tiles': 'Stylish metal tile solutions designed for long-term performance and curb appeal.',
    'flat roofing': 'Reliable flat roofing systems for commercial and industrial applications.',
    'gutters': 'Efficient water drainage systems built for durability and clean installation.',
    'downpipes': 'Complete drainage components for dependable water flow management.',
    'gutter accessories': 'Accessories and fittings to complete your gutter system properly.',
    'hand tools': 'Essential installation tools for precise roofing and sheet metal work.',
    'measure tools': 'Measurement tools that help crews work faster and more accurately.',
    'power tools': 'Professional power tools for faster installation and cleaner results.',
    'roof ventilation': 'Ventilation solutions that help improve airflow and roof system longevity.',
    'roof safety elements': 'Safety-focused components for secure roof access and protection.',
    'soffits': 'Clean finishing elements that improve ventilation and complete the roof edge.',
    'snow guards': 'Protection systems designed to control snow and ice movement safely.',
    'flashings': 'Critical roofing details that help seal transitions and protect vulnerable areas.',
    'trims': 'Finishing components for clean edges, transitions, and professional installation.',
    'coils': 'Sheet metal coil products for fabrication, custom details, and roofing applications.',
    'flat sheets': 'Versatile flat sheet material for trim, flashing, and custom fabrication.',
    'residential': 'Browse materials and systems suited for residential roofing applications.',
    'commercial': 'Solutions tailored for commercial roofing performance and larger project needs.',
    'industrial': 'Heavy-duty systems and components built for industrial roofing environments.',
    'siding': 'Exterior cladding options that combine durability, performance, and clean design.',
    'skylights': 'Roof window solutions that bring more natural light into the building envelope.',
    'workwear': 'Practical apparel and jobsite-ready gear for everyday contractor use.',
    'branded products': 'Company-branded items and supporting products for your team and customers.'
  };

  const collectionImagesScript = document.getElementById('MegaMenuCollectionImages');
  const collectionImageMap = collectionImagesScript
    ? JSON.parse(collectionImagesScript.textContent)
    : {};

  function getPreviewText(label) {
    const key = (label || '').trim().toLowerCase();
    return previewCopyMap[key] || 'Explore this category and view available products.';
  }

  function getCollectionImage(label) {
    const key = (label || '').trim().toLowerCase();
    return collectionImageMap[key] || '';
  }

  function updatePreview(scope, link) {
    const preview = scope.querySelector('[data-mega-preview]');
    const media = scope.querySelector('.mega-menu-preview-card__media');
    const image = scope.querySelector('[data-mega-preview-image]');
    const title = scope.querySelector('[data-mega-preview-title]');
    const text = scope.querySelector('[data-mega-preview-text]');

    if (!preview || !media || !image || !title || !text) return;

    const label = (link.textContent || '').trim();
    const inlineImage = link.querySelector('.mega-menu__link-image');
    const collectionImage = getCollectionImage(label);

    title.textContent = label;
    text.textContent = getPreviewText(label);

    if (inlineImage && inlineImage.getAttribute('src')) {
      image.src = inlineImage.getAttribute('src');
      image.alt = inlineImage.getAttribute('alt') || label;
      image.style.visibility = 'visible';
      media.classList.remove('is-hidden');
    } else if (collectionImage) {
      image.src = collectionImage;
      image.alt = label;
      image.style.visibility = 'visible';
      media.classList.remove('is-hidden');
    } else {
      image.removeAttribute('src');
      image.alt = '';
      image.style.visibility = 'hidden';
      media.classList.add('is-hidden');
    }

    preview.classList.add('is-active');
  }

  function bindPreview(scope) {
    const links = scope.querySelectorAll('.mega-menu__link');
    if (!links.length) return;

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => updatePreview(scope, link));
      link.addEventListener('focus', () => updatePreview(scope, link));
    });

    updatePreview(scope, links[0]);
  }

  document.querySelectorAll('.menu-list__submenu-inner').forEach((submenuInner) => {
    bindPreview(submenuInner);
  });
});